import React from "react";
import { Container } from "react-bootstrap";
import { useParams } from "react-router-dom";
import SideBar from "../Components/SideBar.tsx";
import "./CreateEditPage.css";
import FormClienti from "../Components/FormClienti.tsx";
import FormContratti from "../Components/FormContratti.tsx";
import FormCantieri from "../Components/FormCantieri.tsx";
import FormEventi from "../Components/FormEventi.tsx";

interface CreateEditPageProps {
  action: "crea" | "modifica";
}

const CreateEditPage: React.FC<CreateEditPageProps> = ({ action }) => {
  const { type, id } = useParams();
  console.log(action, type, id);

  const renderForm = () => {
    if (type === "contratti") {
      return <FormContratti action={action} type={type} id={id} />;
    } else if (type === "committente") {
      return <FormClienti action={action} type={type} id={id} />;
    } else if (type === "cantieri") {
      return <FormCantieri action={action} type={type} id={id} />;
    } else if (type === "eventi") {
      return <FormEventi action={action} type={type} id={id} />;
    } else {
      return null;
    }
  };

  return (
    <Container fluid className="d-flex justify-content-between" style={{ margin: "0", padding: "0" }}>
      <Container fluid style={{ margin: "0", padding: "0", width: "5%" }}>
        <SideBar />
      </Container>
      <Container fluid className="colonna">
        <div className="d-flex justify-content-center">
          <div className="containers-crea-edit">{renderForm()}</div>
        </div>
      </Container>
    </Container>
  );
};

export default CreateEditPage;
